module.exports = __webpack_public_path__ + "static/media/History_ArrowRight.052daa37.svg";